import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'lib-rdn-cell',
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    CurrencyPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './recursive-data-navigator-cell.component.html',
  styleUrls: ['./recursive-data-navigator-cell.component.scss']
})
export class RecursiveDataNavigatorCellComponent {
  @Input() row: any;
  @Input() column: any;
  @Input() rowIndex!: number;
  @Input() currentSet: any;
  @Input() isDesktopLayout = true;
  @Input() countOfFilesUploaded = 0;

  @Output() openSet = new EventEmitter<any>();
  @Output() editRecord = new EventEmitter<any>();
  @Output() deleteRecord = new EventEmitter<any>();
  @Output() copyRecord = new EventEmitter<any>(); 
  @Output() sendToken = new EventEmitter<any>();
  @Output() resetPassword = new EventEmitter<any>();
  @Output() resetMFA = new EventEmitter<any>();
  @Output() logInAsUser = new EventEmitter<any>();
  @Output() fileUploadRecord = new EventEmitter<any>();
  @Output() viewFile = new EventEmitter<any>();
  @Output() openInNewWindow = new EventEmitter<any>();
}
